import gql from "graphql-tag";


export const WHATSAPP_GROUPS_QUERY = gql`
  query whatsappGroups($showAll: Boolean, $workoutBlockId: Int) {
    whatsappGroups(showAll:$showAll, workoutBlockId: $workoutBlockId) {
      id
      title
      description
      averageAge
      averageEngagement
      activeBlocks
      maxUsers
      workoutBlock {
        id
        title
      }
      chatregistrationSet {
        edges {
          node {
            id
          }
        }
      }
    }
  }
`;

export const ASSIGN_USERS_TO_WHATSAPP_GROUPS_MUTATION = gql`
  mutation assignUsersToWhatsappGroups($registrations: [WhatsappGroupAssignment]!){ 
    assignUsersToWhatsappGroups(registrations: $registrations) {
      success
    }
  }
`;